import React from "react";
import { Card } from "react-bootstrap";
import "../../assets/css/icons.css";
import CustomDropdown from "./CustomDropdown";
import { withNamespaces } from "react-i18next";

const ErrorWidget = ({ apagarWidget, ...props }) => {
  const { t } = props;
  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {t("general.underConstruction")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body style={{ overflowY: "scroll" }}>
          <p>Não conseguimos obter os dados. Base Widget não existe.</p>
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(ErrorWidget);
